import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
export default function OldSolutionsSection() {
  const failures = ['Melatonina / tés / suplementos: no cortan el hábito mental', 'Videos / meditaciones aleatorias: dependen de encontrar «la correcta» cada noche', '«Relájate» / fuerza de voluntad: cuando estás presionado, relajarte es otra tarea', 'Gadgets / hacks de moda: terminas midiendo el sueño y obsesionándote', 'y cuando fallan, tú te dices: «¿por qué no puedo hacer algo tan básico?»'];
  return <Section className="bg-brand-navy" data-id="element-254">
      <div className="text-center mb-12" data-id="element-255">
        <h2 className="font-heading text-3xl md:text-5xl text-white leading-tight uppercase tracking-wide" data-id="element-256">
          La melatonina no falló… <br className="hidden md:block" data-id="element-257" />
          <span className="text-slate-500" data-id="element-258">
            no ataca el hábito de engancharte a pensamientos.
          </span>
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4 mb-12" data-id="element-259">
        {failures.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.2
      }} className="flex items-start p-4 bg-red-900/10 rounded-lg border border-red-900/20 group hover:bg-red-900/20 transition-colors" data-id="element-260">
            <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          delay: index * 0.2 + 0.1
        }} data-id="element-261">
              <X className="text-red-400 mr-4 mt-1 flex-shrink-0 group-hover:rotate-90 transition-transform duration-300" size={24} data-id="element-262" />
            </motion.div>
            <span className={`text-lg md:text-xl text-slate-400 decoration-slate-600 decoration-2 relative ${index === failures.length - 1 ? 'animate-shake' : ''}`} data-id="element-263">
              <span className="relative z-10 opacity-80" data-id="element-264">{item}</span>
              <motion.span initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            delay: index * 0.2 + 0.3,
            duration: 0.4
          }} className="absolute top-1/2 left-0 h-0.5 bg-slate-600 -translate-y-1/2 z-20" data-id="element-265" />
            </span>
          </motion.div>)}
      </div>

      <div className="text-center" data-id="element-266">
        <motion.p initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 1.5,
        type: 'spring'
      }} className="text-2xl md:text-3xl font-heading text-white uppercase tracking-wide" data-id="element-267">
          No fallaste tú.{' '}
          <span className="bg-brand-indigo/20 text-brand-indigo px-2 py-1 rounded animate-pulse border border-brand-indigo/20" data-id="element-268">
            Falló el enfoque.
          </span>
        </motion.p>
      </div>
    </Section>;
}